import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const AI_NOTICES = {
  interview: "AI-generated panel for practice — not a real department interview. Scores are practice estimates, not a prediction of a real board or a hiring decision, and feedback may be imperfect.",
  resume: "AI suggestions are recommendations, not guarantees of an interview or job. It never adds certifications, jobs or facts — you're responsible for reviewing every detail before you send it.",
  fitness: "AI-built general fitness and nutrition guidance — not medical advice. For injuries, health conditions or individual plans, consult a qualified professional.",
  food: "Calories and macros are approximate AI estimates for everyday tracking. Portion sizes, oils, sauces and hidden ingredients are easy to misjudge — especially from a photo — so adjust anything that looks off.",
  roadmap: "AI suggestions are general guidance. Hiring requirements vary by department and change over time — verify with the agency you're applying to.",
};

export function AiNotice({ kind, dark = false, className = "" }) {
  return (
    <p className={`text-[11px] leading-snug flex items-start gap-1.5 ${dark ? "text-slate-400" : "text-slate-500"} ${className}`} data-testid={`ai-notice-${kind}`}>
      <Sparkles className={`w-3.5 h-3.5 shrink-0 mt-0.5 ${dark ? "text-amber-400" : "text-primary"}`} />
      <span>{AI_NOTICES[kind]} <Link to="/terms#ai" className={`underline ${dark ? "hover:text-white" : "hover:text-primary"}`} data-testid={`ai-notice-link-${kind}`}>AI disclosure</Link></span>
    </p>
  );
}
